import Backbone from 'backbone';
import Question from 'ef/models/question';

/*/ ## EF.Collections.QuestionsCollection
//
// Collection for the questions in a survey or assessment */
const QuestionsCollection = Backbone.Collection.extend({
  model: Question,
});

export default QuestionsCollection;
